var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96967 4.53033C3.67678 4.23744 3.67678 3.76256 3.96967 3.46967C4.26256 3.17678 4.73744 3.17678 5.03033 3.46967L21.0303 19.4697C21.3232 19.7626 21.3232 20.2374 21.0303 20.5303C20.7374 20.8232 20.2626 20.8232 19.9697 20.5303L17.1429 17.7036C15.7337 18.4709 14.16 19 12.5 19C8.68448 19 5.32549 16.2047 3.36971 14.1469C2.2101 12.9268 2.2101 11.0732 3.36971 9.8531C4.19953 8.98001 5.28196 7.97414 6.54468 7.10534L3.96967 4.53033ZM9.91536 10.476C9.65145 10.9227 9.5 11.4436 9.5 12C9.5 13.6569 10.8431 15 12.5 15C13.0564 15 13.5773 14.8486 14.024 14.5846L9.91536 10.476ZM12.5 5C16.3155 5 19.6745 7.79533 21.6303 9.8531C22.7899 11.0732 22.7899 12.9268 21.6303 14.1469C21.1902 14.6099 20.6791 15.1103 20.1078 15.6077L9.9127 5.41264C10.7422 5.15256 11.6086 5 12.5 5Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDisable);
export default __webpack_public_path__ + "static/media/eye-disable.c2583dfffb5556bb27dbae7d6123b81a.svg";
export { ForwardRef as ReactComponent };